import { Link } from '@grubhubprod/gh-cookbook-react';
import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { useParams } from 'react-router-dom';
import { getNotFoundMessage } from 'src/components/oneCorp/features/MealCredit/common/formFields/SelectSearch/getNotFoundMessage';
import { SelectSearch } from 'src/components/SelectSearch/SelectSearch';
import {
  ILocDiner,
  useOneCorpPeopleSearch,
} from 'src/utilities/useSearchHooks';
import { buildCAUIPath, CAUIPage } from 'src/constants/urls';

export interface PeopleSelectSearchProps {
  name: keyof ILocDiner;
}

export default function PeopleSelectSearch({
  name,
}: PeopleSelectSearchProps): JSX.Element {
  const { setValue, register, control } = useFormContext();
  const { defaultValuesRef } = control;
  const { corpid: corpId } = useParams<{ corpid: string }>();

  useEffect(() => {
    register(name, {
      required: true,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name]);

  function noPersonFoundCb(query: string): JSX.Element {
    const message = getNotFoundMessage(query, 'person');
    return (
      <>
        {message}Go to the{' '}
        <Link href={buildCAUIPath(CAUIPage.EMPLOYEES, { corpId })}>
          People page
        </Link>{' '}
        and add person.
      </>
    );
  }

  return (
    <SelectSearch<ILocDiner, false>
      corpId={corpId as string}
      initialSelectedValue={defaultValuesRef.current[name]}
      maxHeight="200px"
      displayProp="name"
      keyName={name}
      placeholder="Select person"
      searchResource={useOneCorpPeopleSearch}
      getNoResultsMessage={noPersonFoundCb}
      inputSize="small"
      onValueChange={(newPerson: ILocDiner) => {
        setValue(name, newPerson.id, {
          shouldValidate: true,
        });
      }}
    />
  );
}
